import { NavLink } from "react-router-dom";
import Logo from "./Logo";
import ProfileMenu from "./ProfileMenu";
import { TAB_LINKS } from "./navLinks";

export default function NavBar() {
  return (
    <nav className="relative z-50 flex items-center justify-between gap-4 px-5 sm:px-8 h-14 box-content pt-[env(safe-area-inset-top)] border-b border-border-soft bg-surface2/30 backdrop-blur-sm flex-shrink-0">
      <NavLink
        to="/"
        className="flex items-center no-underline flex-shrink-0 min-w-0"
        aria-label="CiaoTutor home"
      >
        <Logo variant="compact" />
      </NavLink>

      {/* Desktop: inline links + profile */}
      <div className="hidden sm:flex items-center gap-1 min-w-0">
        <div className="flex items-center gap-1 overflow-x-auto">
          {TAB_LINKS.map(({ to, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `relative px-3 py-1.5 rounded-full text-[0.8125rem] font-medium no-underline whitespace-nowrap transition-colors duration-200 ${
                  isActive
                    ? "text-ink bg-surface2"
                    : "text-text-tertiary hover:text-ink"
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>
        <div className="ml-2 flex items-center flex-shrink-0">
          <ProfileMenu />
        </div>
      </div>

      {/* Mobile: profile anchored right; primary nav lives in the bottom tab bar */}
      <div className="flex sm:hidden items-center flex-shrink-0">
        <ProfileMenu />
      </div>
    </nav>
  );
}
